import DropzoneContainer from './DropzoneContainer';

export default DropzoneContainer;
